<template>
  <div>
    <div v-if="clonedCalendarEntry">
      <div class="flex justify-between">
        <h5>{{ setup.name }}</h5>
        <div class="flex">
          <p class="text-grey m-0 mt-1"><small>priority: </small></p>
          <vs-button
            color="primary"
            type="flat"
            class="py-1 px-2"
            @click="handlePriorityClick('up')"
            :disabled="disableComponent"
          >
            <feather-icon
              icon="ChevronUpIcon"
              svgClasses="h-5 w-5"
              size="small"
            ></feather-icon>
          </vs-button>
          <vs-button
            color="primary"
            type="flat"
            class="py-1 px-2"
            @click="handlePriorityClick('down')"
            :disabled="disableComponent"
          >
            <feather-icon
              icon="ChevronDownIcon"
              svgClasses="h-5 w-5"
              size="small"
            ></feather-icon>
          </vs-button>
        </div>
      </div>
      <div
        style="
          border-bottom: 1px solid lightgray;
          margin-bottom: 1.5rem;
          margin-top: 0.5rem;
        "
      ></div>
      <ul class="leftx flex">
        <li class="mr-2">
          <vs-radio
            v-model="repeatMode"
            :vs-name="'radios-' + setup.id"
            :vs-value="CALENDAR_REPEAT_INTERVAL_TYPE.Weekly"
            :disabled="disableComponent"
            >Weekly</vs-radio
          >
        </li>
        <li class="mr-2">
          <vs-radio
            v-model="repeatMode"
            :vs-name="'radios-' + setup.id"
            :vs-value="CALENDAR_REPEAT_INTERVAL_TYPE.Monthly"
            :disabled="disableComponent"
            >Monthly</vs-radio
          >
        </li>
        <li class="mr-2">
          <vs-radio
            v-model="repeatMode"
            :vs-name="'radios-' + setup.id"
            :vs-value="CALENDAR_REPEAT_INTERVAL_TYPE.Yearly"
            :disabled="disableComponent"
            >Yearly</vs-radio
          >
        </li>
        <li class="mr-2">
          <vs-radio
            v-model="repeatMode"
            :vs-name="'radios-' + setup.id"
            :vs-value="undefined"
            :disabled="disableComponent"
            >Dates</vs-radio
          >
        </li>
      </ul>
      <div>
        <component
          :is="scheduleComponent"
          v-model="clonedCalendarEntry"
          :setup-id="setup.id"
          :disable-component="disableComponent"
        />
      </div>

      <vs-button
        @click="save()"
        class="mt-6 mr-2"
        :disabled="
          disableComponent ||
          !isDirty ||
          repeatMode === CALENDAR_REPEAT_INTERVAL_TYPE.Monthly
        "
        >Save</vs-button
      >
      <vs-button
        type="border"
        @click="handleResetClick()"
        class="mt-6"
        :disabled="disableComponent || !isDirty"
        >Reset</vs-button
      >
    </div>
    <div v-if="!clonedCalendarEntry">
      <div class="flex justify-between">
        <h5>{{ setup.name }}</h5>
      </div>
      <div
        style="
          border-bottom: 1px solid lightgray;
          margin-bottom: 1.5rem;
          margin-top: 0.5rem;
        "
      ></div>
      <div>No schedule for this setup yet</div>
      <vs-button
        @click="handleAddCalendarEntryClick()"
        class="mt-6"
        :disabled="disableComponent"
        >Add schedule</vs-button
      >
    </div>
  </div>
</template>

<script>
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import * as _ from "lodash";
import {
  VenueSetupCalendarEntry,
  CALENDAR_REPEAT_INTERVAL_TYPE,
  WeeklyRepeatInterval,
  MonthlyRepeatInterval,
  YearlyRepeatInterval,
} from "@/store/modules/marcom/data-model/calendar";
import WeeklySchedule from "./components/WeeklySchedule.vue";
import MonthlySchedule from "./components/MonthlySchedule.vue";
import YearlySchedule from "./components/YearlySchedule.vue";
import DatesSchedule from "./components/DatesSchedule.vue";

export default {
  props: {
    setup: Object,
    calendarEntry: Object,
    disableComponent: Boolean,
  },
  components: {
    WeeklySchedule,
    MonthlySchedule,
    YearlySchedule,
    DatesSchedule,
  },
  data() {
    return {
      CALENDAR_REPEAT_INTERVAL_TYPE,
      clonedCalendarEntry: undefined,
      isDirty: false,
    };
  },
  computed: {
    repeatMode: {
      get() {
        if (!this.clonedCalendarEntry.calendarRepeatInterval) return undefined;
        return this.clonedCalendarEntry.calendarRepeatInterval.type;
      },
      set(value) {
        switch (value) {
          case undefined: {
            if (this.calendarEntry && this.calendarEntry.calendarRepeatInterval)
              this.clonedCalendarEntry.dates = [];
            this.clonedCalendarEntry.calendarRepeatInterval = undefined;
            break;
          }
          case CALENDAR_REPEAT_INTERVAL_TYPE.Weekly: {
            this.clonedCalendarEntry.calendarRepeatInterval =
              new WeeklyRepeatInterval();
            break;
          }
          case CALENDAR_REPEAT_INTERVAL_TYPE.Monthly: {
            this.clonedCalendarEntry.calendarRepeatInterval =
              new MonthlyRepeatInterval();
            break;
          }
          case CALENDAR_REPEAT_INTERVAL_TYPE.Yearly: {
            this.clonedCalendarEntry.calendarRepeatInterval =
              new YearlyRepeatInterval();
            break;
          }
        }
      },
    },
    scheduleComponent() {
      if (!this.clonedCalendarEntry.calendarRepeatInterval)
        return "DatesSchedule";
      if (
        this.clonedCalendarEntry.calendarRepeatInterval.type ===
        CALENDAR_REPEAT_INTERVAL_TYPE.Weekly
      )
        return "WeeklySchedule";
      if (
        this.clonedCalendarEntry.calendarRepeatInterval.type ===
        CALENDAR_REPEAT_INTERVAL_TYPE.Monthly
      )
        return "MonthlySchedule";
      if (
        this.clonedCalendarEntry.calendarRepeatInterval.type ===
        CALENDAR_REPEAT_INTERVAL_TYPE.Yearly
      )
        return "YearlySchedule";
    },
  },
  watch: {
    clonedCalendarEntry: {
      handler: function (val, oldVal) {
        this.isDirty = !_.isEqual(this.calendarEntry, this.clonedCalendarEntry);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.calendarEntry) {
      this.clonedCalendarEntry = _.cloneDeep(this.calendarEntry);
    }
  },
  methods: {
    handleAddCalendarEntryClick() {
      const venueDetailsId = this.setup.VenueSetupId;
      const venueSetupId = this.setup.VenueSetupId;
      this.clonedCalendarEntry = new VenueSetupCalendarEntry(
        venueDetailsId,
        venueSetupId
      );
    },
    handlePriorityClick(direction) {
      this.$emit("priority-changed", {
        calendarEntry: this.calendarEntry,
        direction: direction,
      });
    },
    handleResetClick() {
      this.clonedCalendarEntry = _.cloneDeep(this.calendarEntry);
      setTimeout(() => {
        this.isDirty = false;
      }, 50);
    },
    async save() {
      try {
        this.$vs.loading();
        let venueSetupCalendarEntryId;
        if (!this.calendarEntry) {
          let defaultEntryCommand = {
            setupId: this.setup.id,
          };
          venueSetupCalendarEntryId = await this.$store.dispatch(
            "marcom/" + VENUE_ACTIONS.AddDefaultCalendarEntry,
            defaultEntryCommand
          );
        } else {
          venueSetupCalendarEntryId =
            this.calendarEntry.venueSetupCalendarEntryId;
        }

        if (this.repeatMode === CALENDAR_REPEAT_INTERVAL_TYPE.Weekly) {
          //Update model
          let command = {
            calenderEntryId: venueSetupCalendarEntryId.id,
            repeatOnDays:
              this.clonedCalendarEntry.calendarRepeatInterval.repeatOnDays,
          };

          //Call service
          let result = await this.$store.dispatch(
            "marcom/" + VENUE_ACTIONS.PostCalendarDatesByWeeklyInterval,
            command
          );
        } else if (this.repeatMode === CALENDAR_REPEAT_INTERVAL_TYPE.Yearly) {
          //Update model
          let yearlyCommand = {
            calenderEntryId: venueSetupCalendarEntryId.id,
            dates:
              this.clonedCalendarEntry.calendarRepeatInterval.repeatOnDates.filter(
                (d) => d !== undefined
              ),
          };

          //Call service
          let yearlyResult = await this.$store.dispatch(
            "marcom/" + VENUE_ACTIONS.PostCalendarDatesByYearlyInterval,
            yearlyCommand
          );
        } else if (this.repeatMode === undefined) {
          //Update model
          let datesCommand = {
            calenderEntryId: venueSetupCalendarEntryId.id,
            dates: this.clonedCalendarEntry.dates.filter(
              (d) => d !== undefined
            ),
          };

          //Call service
          let result = await this.$store.dispatch(
            "marcom/" + VENUE_ACTIONS.PostCalendarDatesByDateList,
            datesCommand
          );
        }

        this.$vs.notify({
          color: "success",
          title: "Schedule updated",
          text: "Your schedule was updated",
        });
      } catch (err) {
        this.$vs.notify({
          color: "danger",
          title: "Error while updating Schedule",
          text: "Unable to update Schedule",
        });
      } finally {
        this.$vs.loading.close();

        //this.isUpdated = false;
      }
    },
  },
};
</script>
